import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './currency-index.reducer';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const CurrencyIndexDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const userAuthorities = useAppSelector(state => state.authentication.account.authorities);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const currencyIndexEntity = useAppSelector(state => state.currencyIndex.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="currencyIndexDetailsHeading">
          <Translate contentKey="comexApp.currencyIndex.detail.title">CurrencyIndex</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{currencyIndexEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="comexApp.currencyIndex.name">Name</Translate>
            </span>
          </dt>
          <dd>{currencyIndexEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="comexApp.currencyIndex.description">Description</Translate>
            </span>
          </dt>
          <dd>{currencyIndexEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="comexApp.currencyIndex.active">Active</Translate>
            </span>
          </dt>
          <dd>{currencyIndexEntity.active ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/currency-index" replace data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        {userAuthorities.includes(AUTHORITIES.ADMIN) && (
          <Button tag={Link} to={`/currency-index/${currencyIndexEntity.id}/edit`} replace color="primary">
            <FontAwesomeIcon icon="pencil-alt" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </span>
          </Button>
        )}
      </Col>
    </Row>
  );
};

export default CurrencyIndexDetail;
